import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/landing/Shared";

const NextStep = ({
  overline = "Next",
  title,
  description,
  to,
  cta = "Continue",
  testId = "next-step",
}) => {
  return (
    <section
      data-testid={testId}
      className="relative py-24 sm:py-32 border-t"
      style={{ borderColor: "var(--forr-line-soft)" }}
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        <Reveal>
          <Link
            to={to}
            data-testid={`${testId}-link`}
            className="group block rounded-[24px] p-8 sm:p-12 forr-card"
          >
            <div className="grid grid-cols-12 gap-6 items-center">
              <div className="col-span-12 md:col-span-8">
                <div className="forr-overline mb-4">
                  {overline}
                </div>
                <h3 className="font-display forr-text-ink text-2xl sm:text-3xl font-medium tracking-tight leading-tight">
                  {title}
                </h3>
                {description && (
                  <p className="mt-4 forr-text-soft font-light leading-relaxed max-w-2xl">
                    {description}
                  </p>
                )}
              </div>
              <div className="col-span-12 md:col-span-4 flex md:justify-end">
                <span className="inline-flex items-center gap-3 forr-text-teal-deep group-hover:forr-text-teal transition-colors text-sm font-medium tracking-wide">
                  {cta}
                  <ArrowRight
                    size={18}
                    strokeWidth={1.75}
                    className="transition-transform duration-300 group-hover:translate-x-1.5"
                  />
                </span>
              </div>
            </div>
          </Link>
        </Reveal>
      </div>
    </section>
  );
};

export default NextStep;
